"use strict";

(function ($) {
  $(window).on("load", function () {
    const $floatingBtnsWrap = $("#floating-btns");
    let $floatingBtns = $floatingBtnsWrap.find(".btn-floating");
    let hoverClass = "hover-on-floating-btn";
    let initialReveal = true;
    let visibleAmount = 44; //px
    let cookieName = "hoas-floating-buttons-shown";
    let hoasFloatingButtonsExposed = window.getCookie(cookieName);

    /* Button loop */
    $floatingBtns.each(function (el) {
      let $this = $(this);

      let thisRight = Math.round($this.outerWidth()) - visibleAmount;

      $this.css({
        "margin-right": -Math.abs(thisRight),
      });

      // Only Expand into view, if user hasn't already seen these as expanded
      if (hoasFloatingButtonsExposed !== "true") {
        $this.addClass(hoverClass);

        $this.on("mouseleave", function () {
          $this.removeClass(hoverClass);
        });
      }
    });

    /**
     * SCROLL Action
     */
    $(window).scroll(function () {
      // If the first time we encounter the buttons, remove the force reveal class, set a cookie, end set the initial variable to false
      if (initialReveal) {
        if ($(window).scrollTop() > 100) {
          // Set cookie data
          window.setCookie(cookieName, "true", false); // use false to prevent expiration -> is a session cookie
          // Remove force show class
          $floatingBtns.removeClass(hoverClass);
          // Set as shown
          initialReveal = false;
        }
      }
    });
  });

  // Doc ready
  $(function () {
    // Delegate the bottom bar giosg button click to the #hoas-giosg-button, which launches the chat
    // This way we avoid the duplicate ids, but can still access the chat, bound to #hoas-giosg-button
    $("#hoas-giosg-button--bottom-bar").on("click", function (evt) {
      $("#hoas-giosg-button").trigger("click");
    });
  });
})(jQuery);
